import { Table, Input, Button, Checkbox } from "antd";
import React, { useState } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";
import { getDateFormat } from "../utility/utility";
import resources from "../resources";
import '../styles/component/common-table.scss';

interface gridInterFace {
    userData?: {}[],
    rowKey?: string,
    components?: {},
    dataSource?: any[],
    columns?: any[],
    pagination?: boolean,
    onChange?: (_pagination: any, filters: any, sorter: any) => void,
    onRowClick?: (record: any) => void;
    rowClassName?: string,
    bordered: boolean,
    scrollable?: boolean,
    pageNumber?: number,
    pageSize?: number,
    handlePrevPage?: () => void;
    handleNextPage?: () => void;
    paginationButton?: boolean;
}

const tempResource = resources.commonButtonText;
const Grid = (props: gridInterFace) => {
    const [searchText, setSearchText] = useState("");
    const generateColumns = () => {
        return props.columns?.map((col: any) => {
            const newCol = {...col};


            if (col.sortable === true && col.isDateFormat) {
                newCol.sorter = (a: any, b: any) => {
                    const timeA = new Date(a['date']);
                    const timeB = new Date(b['date']);
                    return timeA.getTime() - timeB.getTime();
                };
            } else if (col.sortable === true) {
                newCol.sorter = (a: any, b: any) =>
                    (a[col.dataIndex] || "").toString().localeCompare((b[col.dataIndex] || "").toString());
            }


            if (col.filterable) {
                newCol.filterDropdown = ({setSelectedKeys, selectedKeys, confirm, clearFilters}: any) => {
                    const rawOptions = Array.from(
                        new Set((props.dataSource || []).map(item => {
                            if (col.isDateFormat) {
                                return getDateFormat(item[col.dataIndex]);
                            } else if (col.isDataTypeConvertable?.isConvertable) {
                                return col.isDataTypeConvertable.leaveDataType[item[col.dataIndex] as keyof typeof col.isDataTypeConvertable.leaveDataType]
                            } else if (col.datatypeCovert?.isConvertable) {
                                return col.datatypeCovert.holidayDatatype[item[col.dataIndex] as keyof typeof col.datatypeCovert.holidayDatatype]
                            } else if (col.DataTypeConvertable?.isConvertable) {
                                return col.DataTypeConvertable.leaveStatusDataTYpe[item[col.dataIndex] as keyof typeof col.DataTypeConvertable.leaveStatusDataTYpe]
                            }
                            return item[col.dataIndex];
                        }))
                    );

                    const filtered = rawOptions.filter(option =>
                        option?.toString().toLowerCase().includes(searchText.toLowerCase())
                    );

                    return (
                        <div className={'common-table-search-card'}>
                            <Input
                                placeholder={`Search ${col.title}`}
                                value={searchText}
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                }}
                                className={'common-table-search-input'}
                            />
                            <div className={'common-table-search-card-all-options'}>
                                {filtered.length > 0 ? (
                                    filtered.map((option: any) => (
                                        <div key={option} className={'common-table-search-option'}>
                                            <Checkbox
                                                checked={selectedKeys?.includes(option)}
                                                onChange={(e) => {
                                                    const SelectedValues = e.target.checked
                                                        ? [...selectedKeys, option]
                                                        : selectedKeys.filter((key: any) => key !== option);
                                                    setSelectedKeys(SelectedValues);
                                                }}
                                            />
                                            <span>{option}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className={'commom-table-search-result-not-found'}>Result not found !</div>
                                )}
                            </div>
                            <Button
                                type="primary"
                                onClick={() => {
                                    confirm();
                                    setSearchText("");
                                }}
                                size="small"
                                className={'common-table-search-button'}
                            >
                                {tempResource.searchButton}
                            </Button>
                            <Button
                                onClick={() => {
                                    clearFilters();
                                    confirm();
                                    setSearchText("");
                                }}
                                size="small"
                                className={'common-table-reset-button'}
                            >
                                {tempResource.resetButton}
                            </Button>
                        </div>
                    );
                };

                newCol.filterIcon = (filtered: boolean) => (
                    <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}}/>
                );

                newCol.onFilter = (value: any, record: any) => {
                    let recordValue;

                    if (col.isDateFormat) {
                        recordValue = getDateFormat(record[col.dataIndex]);
                    } else if (col.isDataTypeConvertable?.isConvertable) {
                        recordValue = col.isDataTypeConvertable.leaveDataType[
                            record[col.dataIndex] as keyof typeof col.isDataTypeConvertable.leaveDataType
                            ];
                    } else if (col.datatypeCovert?.isConvertable) {
                        recordValue = col.datatypeCovert.holidayDatatype[
                            record[col.dataIndex] as keyof typeof col.datatypeCovert.holidayDatatype
                            ];
                    } else if (col.DataTypeConvertable?.isConvertable) {
                        recordValue = col.DataTypeConvertable.leaveStatusDataTYpe[
                            record[col.dataIndex] as keyof typeof col.DataTypeConvertable.leaveStatusDataTYpe
                            ];
                    } else {
                        recordValue = record[col.dataIndex];
                    }

                    return recordValue?.toString().toLowerCase().includes(value.toString().toLowerCase());
                };
            }

            return newCol;
        }) || [];
    };

    return (
        <>
            <Table
                components={props.components}
                onRow={(record) => ({
                    onClick: () => props.onRowClick ? props.onRowClick(record) : {},
                })}
                rowKey={props.rowKey || "id"}
                bordered={props.bordered}
                dataSource={props.dataSource}
                columns={generateColumns()}
                rowClassName={props.rowClassName || "editable-row"}
                scroll={props.scrollable ? {x: 'max-content'} : {}}
                onChange={props.onChange}
                className={'hrms__table-component'}
                pagination={
                    // used in without paginated APIs
                    props.pagination === true && {
                        className: "pagination-buttons",
                        pageSize: 8,
                        hideOnSinglePage: true,
                        itemRender: (_: any, type: any) => {
                            if (type === "prev") {
                                return (
                                    <Button icon={<ArrowLeftOutlined/>}>
                                        Previous
                                    </Button>
                                );
                            }
                            if (type === "next") {
                                return (
                                    <Button icon={<ArrowRightOutlined/>} iconPosition="end">
                                        Next
                                    </Button>
                                );
                            }
                            return null;
                        },
                        simple: false,
                    }
                }
            />
            {
                // used in paginated APIS
                props.paginationButton === true && props.dataSource &&
                <div className="pagination-button-div">
                    <Button
                        className={'pagination-button'}
                        disabled={props.pageNumber === 0}
                        onClick={props.handlePrevPage}
                    >
                        <ArrowLeftOutlined/> Previous
                    </Button>

                    <Button
                        className={'pagination-button'}
                        disabled={(props.dataSource?.length || 0) < (props.pageSize || 0)}
                        onClick={props.handleNextPage}
                    >
                        Next <ArrowRightOutlined/>
                    </Button>
                </div>
            }
        </>
    );

};

export default Grid;
